import { camelCase, upperFirst } from 'lodash-es';

const getArticleSubjectType = (
  prefix: string,
  hasLocalNews: boolean,
) => (
  hasLocalNews
    ? upperFirst(`${camelCase(prefix)}NewsArticle`)
    : 'NewsArticle'
);

export default getArticleSubjectType;
